import { ICheckableObject, instanceOfICheckableObject } from "./ICheckableObject";
import {
  ICheckStyle,
  IQuestionnaireSpecifiable, instanceOfIQuestionnaireSpecifiable,
} from "../../../../documaker/domain/format/objects";

export interface ICheckObject extends ICheckableObject, IQuestionnaireSpecifiable {
  checkStyle: ICheckStyle;
}

export function instanceOfICheckObject(instance: any): instance is ICheckObject {
  return instance
      && (instance.checkStyle !== undefined)
      && instanceOfIQuestionnaireSpecifiable(instance)
      && instanceOfICheckableObject<ICheckObject>(instance, "check");
}
